export default {"src":"/_next/static/media/gray-dimensional-chain.1ca9ad32.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};